<form fxLayout="column" fxLayoutGap="20px">
  <h1 mat-dialog-title>Confirm Deletion</h1>
  <div mat-dialog-content>
    Are you sure you want to delete this user?
  </div>
  <div mat-dialog-actions fxLayout="row" fxLayoutAlign="end center" fxLayoutGap="10px">
    <button mat-button mat-dialog-close>Cancel</button>
    <button mat-raised-button color="warn" (click)="onDelete()">DELETE</button>
  </div>
</form>
